import React from 'react';
import PageHeader from '../components/PageHeader';
import BookingSection from '../components/BookingSection';
import CTABoxes from '../components/CTABoxes';

const BookingPage = () => (
  <>
    <PageHeader
      eyebrow="Book Online"
      title="Book a Time That Works for You"
      description="Choose your preferred day and time slot — we'll call you back to confirm the booking."
    />
    <BookingSection />
    <CTABoxes />
  </>
);

export default BookingPage;
